import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useApi } from '@axiom/ui';

import { CandidateEngagementsApi } from '../../api/candidate-engagements-api';
import { useCandidateId } from '../../hooks/useCandidateId';

export const EngagementsHistoryViewRedirect = () => {
  const navigate = useNavigate();
  const candidateId = useCandidateId();

  const [{ data: counts }] = useApi(
    CandidateEngagementsApi.readEngagementsCount(candidateId)
  );

  useEffect(() => {
    if (counts.pastInterestHistoryTotal > 0) {
      void navigate('./interest');
    } else if (counts.pastSubmissionHistoryTotal > 0) {
      void navigate('./submissions');
    } else if (counts.pastEngagementHistoryTotal > 0) {
      void navigate('./engagements');
    } else {
      void navigate('../v2');
    }
  }, [counts]);

  return null;
};
